import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ym from 'react-yandex-metrika';

function usePageViews() {
  const location = useLocation();

  useEffect(() => {
    ym('hit', location.pathname + location.search);
  }, [location]);
}

export default usePageViews;
